import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth, apiError } from "@/context/AuthContext";
import { toast } from "sonner";
import { Sparkles } from "lucide-react";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", inviteCode: "" });
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form.name, form.email, form.password, form.inviteCode);
      toast.success("Conta criada!");
      nav("/onboarding");
    } catch (err) {
      toast.error(apiError(err, "Não foi possível criar sua conta."));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-10 grain">
      <div className="w-full max-w-md">
        <div className="mb-8">
          <div className="flex items-center gap-2 mb-2">
            <div className="w-9 h-9 rounded-xl bg-[#682F3E] flex items-center justify-center">
              <Sparkles size={18} className="text-[#EBD8D2]" strokeWidth={1.8} />
            </div>
            <span className="font-display text-xl font-bold text-[#27272A]">NailControl</span>
          </div>
          <h1 className="font-display text-3xl font-bold text-[#27272A]">Criar sua conta</h1>
          <p className="text-[#71717A] text-sm mt-1">Use o código de acesso recebido após a compra.</p>
        </div>

        <form onSubmit={onSubmit} className="card-nc p-6 space-y-4" data-testid="register-form">
          <div>
            <label className="block text-xs font-semibold uppercase tracking-wide text-[#71717A] mb-1.5">Nome</label>
            <input data-testid="register-name" required value={form.name} onChange={set("name")}
              className="w-full h-12 px-3 rounded-xl border border-[#E4E4E7] focus:border-[#682F3E] focus:ring-2 focus:ring-[#682F3E]/10 outline-none" />
          </div>
          <div>
            <label className="block text-xs font-semibold uppercase tracking-wide text-[#71717A] mb-1.5">E-mail</label>
            <input data-testid="register-email" type="email" required value={form.email} onChange={set("email")}
              className="w-full h-12 px-3 rounded-xl border border-[#E4E4E7] focus:border-[#682F3E] focus:ring-2 focus:ring-[#682F3E]/10 outline-none" />
          </div>
          <div>
            <label className="block text-xs font-semibold uppercase tracking-wide text-[#71717A] mb-1.5">Senha</label>
            <input data-testid="register-password" type="password" minLength={8} maxLength={128} required value={form.password} onChange={set("password")}
              className="w-full h-12 px-3 rounded-xl border border-[#E4E4E7] focus:border-[#682F3E] focus:ring-2 focus:ring-[#682F3E]/10 outline-none" />
            <p className="text-xs text-[#71717A] mt-1">Mínimo 8 caracteres.</p>
          </div>
          <div>
            <label className="block text-xs font-semibold uppercase tracking-wide text-[#71717A] mb-1.5">Código de acesso</label>
            <input
              data-testid="register-invite-code"
              required
              autoCapitalize="characters"
              value={form.inviteCode}
              onChange={set("inviteCode")}
              placeholder="NC-XXXX-XXXX"
              className="w-full h-12 px-3 rounded-xl border border-[#E4E4E7] focus:border-[#682F3E] focus:ring-2 focus:ring-[#682F3E]/10 outline-none font-mono-brand uppercase"
            />
            <p className="text-xs text-[#71717A] mt-1">Cada código pode ser usado uma única vez.</p>
          </div>
          <button data-testid="register-submit" disabled={loading} className="btn-primary-nc w-full">
            {loading ? "Criando…" : "Criar conta"}
          </button>
          <div className="text-center text-sm text-[#71717A]">
            Já tem conta?{" "}
            <Link data-testid="link-login" to="/login" className="text-[#682F3E] font-semibold hover:underline">Entrar</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
